<template>
    <div>
        <ProductReleasedWarehouseList />
    </div>
</template>

<script>
import ProductReleasedWarehouseList from "@/components/adminArin/pos_system/warehouse/productreleasedwarehouselist/Product_released_warehouse_list";
export default {
    name: "Product_released_warehouse_list",
    components: {
        ProductReleasedWarehouseList
    }
}
</script>

<style scoped>

</style>
